import { ConfirmOrder, EditOrder, Loader, OrderDisplay, ProductionEntry } from '../Widgets';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { RootState } from 'store/store';
import { useSelector } from 'react-redux';
import ArthaGateway from 'service/ArthaGateway';
import { Party, SaleOrder, Product, OrderItem, OrderDocument, ProductMaster, ProductStyle, OrderStatuses, User } from 'service';
import defaultImage from "../../assets/default.png"
import { faChevronLeft, faFile, faGripVertical, faTableCells, faTableList, faTrash, faPlus, faMinus, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import toast, { Toaster } from 'react-hot-toast';
import { useParams } from 'react-router';

export const OrderDetails = () => {
    const userData = useSelector((state: RootState) => state.appdata);
    const [user, setUser] = useState<User>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [order, setOrder] = useState<SaleOrder>(new SaleOrder());
    const [isCancelling, setIsCancelling] = useState<boolean>(false);
    const [cancelComment, setCancelComment] = useState<string>("");
    const [activeTab, setActiveTab] = useState<string>("details");

    const params = useParams();
    const orderId = params.id ? parseInt(params.id) : 0;

    const navigate = useNavigate();

    useEffect(() => {
        if (userData.profile) {
            setUser(userData.profile.profile);
            setIsLoading(false);
        }
    }, [userData]);

    useEffect(() => {
        if (orderId > 0) {
            loadOrderDetails();
        }
    }, [orderId]);

    const loadOrderDetails = () => {
        if (orderId <= 0) {
            return;
        }
        ArthaGateway.getSalesOrder(orderId).then((data) => {
            setOrder(data);
            setIsLoading(false);
        }).catch(error => {
            toast.error("Error loading order details");
            setIsLoading(false);
            console.log(error);
        });
    };

    const getDisplayImage = (item) => {
        if (item.customImageUrl && item.customImageUrl.length > 0) {
            return item.customImageUrl;
        }
        if (item.style?.imageUrl) {
            return item.style.imageUrl;
        }
        if (item.productMaster?.imageUrl) {
            return item.productMaster.imageUrl;
        }
        // Return null if no image
        return null;
    };

    const handleCancelOrder = () => {
        if (cancelComment.trim().length == 0) {
            toast.error("Please provide a reason for cancellation");
            return;
        }
        setIsLoading(true);
        ArthaGateway.cancelSalesOrder(order.id, cancelComment, 1).then(() => {
            toast.success("Order cancelled successfully");
            loadOrderDetails();
            setCancelComment("");
            setIsCancelling(false);
        }).catch(error => {
            toast.error("Error cancelling order");
            setIsLoading(false);
            console.log(error);
        });
    };

    const currencyFormat = (value) =>
        new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(value);

    return (
        <div className='page page-order-details'>
            {isLoading &&
                <Loader />
            }
            {!isLoading &&
                <>
                    <div className='row'>
                        <div className='col-12 col-md-6 col-lg-4 offset-md-3 offset-lg-4 my-2'>
                            <div><Toaster /></div>
                            {activeTab == "details" && (
                                <OrderDisplay order={order} user={user} onSetActiveTab={setActiveTab} />
                            )}
                            {activeTab == "addProduction" && (
                                <ProductionEntry source={order} user={user} onSetActiveTab={setActiveTab} onOrderUpdated={() => {
                                    loadOrderDetails();
                                    setActiveTab('details');
                                }} />
                            )}
                            {activeTab == "confirmOrder" && (
                                <ConfirmOrder source={order} user={user} onSetActiveTab={setActiveTab} onOrderUpdated={() => {
                                    loadOrderDetails();
                                    setActiveTab('details');
                                }} />
                            )}
                            {activeTab == "updateQuantity" && (
                                <EditOrder source={order} user={user} onSetActiveTab={setActiveTab} onOrderUpdated={() => {
                                    loadOrderDetails();
                                    setActiveTab('details');
                                }} />
                            )}
                        </div>
                    </div>
                    {activeTab == "details" && (
                        <div className="row mb-2">
                            <div className="col-12 col-md-6 col-lg-4 offset-md-3 offset-lg-4">
                                <button type="button" className="btn btn-danger btn-sm w-100" onClick={() => { navigate(-1) }}>Back to order list</button>
                            </div>
                        </div>
                    )}
                </>
            }
        </div>
    );
};